module.exports = __webpack_public_path__ + "static/media/video_br_video.35bd0b71.mp4";